import { defaultConfig, defineTokens } from '@chakra-ui/react';

const animations = defineTokens.animations({
    ...defaultConfig.theme?.tokens?.animations,
    scroll: { value: 'scroll 30s linear infinite' },
});

export { animations };
